<template>
    <div class="card-counter">
        <i :class="data.icon"></i>
        <span class="count-title">{{ data.name }}</span>
        <!-- <span class="count-subtitle">{{ data.id }}</span> -->
    </div>
</template>


<script>
export default {
    name: "BoxC",
    props:{
        data: {
            type: Object
        },
    },
    setup() {
        return {};
    },
}
</script>


<style lang="scss" scoped>
.card-counter{
    position: relative;
    box-shadow: 2px 2px 10px #DADADA;
    // box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    // margin: 5px;
    padding: 20px 10px;
    background-color: #fff;
    height: 100px;
    border-radius: 5px;
    transition: .3s linear all;
  }

  .card-counter:hover{
    box-shadow: 4px 4px 20px #DADADA;
    transition: .3s linear all;
  }

  .card-counter.primary{
    background-color: #007bff;
    color: #FFF;
  }

  .card-counter.danger{
    background-color: #ef5350;
    color: #FFF;
  }

  .card-counter.success{
    background-color: #66bb6a;
    color: #FFF;
  }

  .card-counter.info{
    background-color: #26c6da;
    color: #FFF;
  }

  .card-counter i{
    font-size: 5em;
    opacity: 0.2;
  }

  .card-counter .count-title{
    position: absolute;
    right: 35px;
    top: 20px;
    font-size: 32px;
    display: block;
  }

  .card-counter .count-subtitle{
    position: absolute;
    right: 35px;
    top: 65px;
    font-style: italic;
    text-transform: capitalize;
    opacity: 0.5;
    display: block;
    font-size: 18px;
  }
</style>